import React, { useEffect, createElement } from 'react';
export const GoogleTagManager = ({
  gtmId = 'GTM-WMX37DT6'
}) => {
  useEffect(() => {
    // Insert the GTM script into the head
    const script = document.createElement('script');
    script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');
    `;
    document.head.insertBefore(script, document.head.firstChild);
    return () => {
      // Clean up if component unmounts (though this is unlikely at app level)
      document.head.removeChild(script);
    };
  }, [gtmId]);
  return <>
      {/* Google Tag Manager (noscript) */}
      <noscript data-id="element-243">
        <iframe src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`} height="0" width="0" style={{
        display: 'none',
        visibility: 'hidden'
      }} title="GTM" data-id="element-244" />
      </noscript>
    </>;
};